export enum ControlObjectCategory {
    People = 'person',
    Equipment = 'equipment',
    Asset = 'asset'
}
